export default "__VITE_ASSET__Y7oC2SLJ__"